import React, { useRef } from 'react';
import { bool, func, string } from 'prop-types';

import { chainHandlers } from 'utils/chain-handlers';
import { useNavigation } from 'components/MegaMenu/NavigationProvider';
import { SignOut as SignOutIcon } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import urls from 'constants/urls';

import styles from './SignOut.scss';

const SignOut = ({
  className = null,
  isSignedOnAsCustomer,
  loggedIn,
  onBlur = null,
  onClick = null,
  onFocus = null,
}) => {
  const visible = loggedIn && !isSignedOnAsCustomer;
  const ref = useRef();
  const { handleClick, handleKeyDown, tabIndex } = useNavigation(ref, {
    skip: !visible,
  });

  return visible ? (
    <a
      className={className}
      data-test="signOut"
      href={urls.logout}
      onBlur={onBlur}
      onClick={chainHandlers(handleClick, onClick)}
      onFocus={onFocus}
      onKeyDown={handleKeyDown}
      ref={ref}
      tabIndex={tabIndex}
    >
      <SignOutIcon className={styles.icon} size="small" />
      Sign out
    </a>
  ) : null;
};

SignOut.propTypes = {
  className: string,
  isSignedOnAsCustomer: bool.isRequired,
  loggedIn: bool.isRequired,
  onBlur: func,
  onClick: func,
  onFocus: func,
};

SignOut.displayName = 'SignOut';

export default SignOut;
